module.exports = __webpack_public_path__ + "6c04c071a93c4ff341dfff3105745785.svg";